<template>
    <div class="container">
        <div class="container-header-integration">
            <div class="integration-erps">INTEGRAÇÕES ERPs</div>
            <header-integration-erp
                title="Empreendimentos"
                subtitle="Crie e gerencie novas integrações de disponibilidade com os ERPs"
            />
        </div>

        <div class="container-table-row">
            <div class="container-table-row-form">
                <ui-select-v2
                    v-model="filter.integration_type"
                    :data="integrationTypeOptions"
                    item-label="label"
                    return-value="value"
                    design="br-all"
                    size="md"
                    label="Tipo de Integração:"
                    @input="selectHandler"
                />
            </div>

            <div class="container-table-row-form">
                <ui-select-v2
                    v-model="filter.availability_type"
                    :data="availabilityTypeOptions"
                    item-label="label"
                    label="Disponibilidade:"
                    return-value="value"
                    design="br-all"
                    size="md"
                    @input="selectHandler"
                />
            </div>

            <div class="container-table-row-search">
                <ui-search-box
                    v-model="filter.search"
                    event="search-integration-availability"
                    placeholder="Buscar Empreendimento"
                />
            </div>
        </div>

        <div class="container-found-button-integrate">
            <div class="found-integration">Encontramos {{ filter.total }} empreendimento(s) integrado(s)</div>
            <div class="button-integrate">
                <ui-button design="success md" @click="newAvailabilityHandler">
                    + Integrar Empreendimento
                </ui-button>
            </div>
        </div>

        <table-row :contents="data" :loading="loading" class="table-products"/>

        <div class="load-more">
            <ui-button v-if="nextPage" design="line mw-250 lg" @click="loadNextPage">
                Carregar Mais
            </ui-button>
        </div>
    </div>
</template>

<script>
	import { HeaderIntegrationErp } from '@/components/ui-facilita/marketing/erp/menu-card-erp'
	import { uiSelectV2 } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSearchBox } from '@/components/ui'
	import TableRow from './components/table-row'

	import { erp, s3Filesystem } from '@/services/axios'

	import { mapGetters, mapActions } from 'vuex'

	import { utilMixin } from '@/mixins'

	export default {
		name: 'ui-integrations-erp-products',

		components: {
			TableRow,
			HeaderIntegrationErp,
			uiSelectV2,
			uiButton,
			uiSearchBox
		},

		mixins: [utilMixin],

		data() {
			return {
				filter: {
					search: '',
					integration_type: '',
					availability_type: '',
					last_page: 1,
					per_page: 13,
					total: 0,
					page: 1,
				},
				loading: false,
				integrationTypeOptions: [],
				availabilityTypeOptions: [
					{
						value: 'vertical',
						label: 'Vertical',
					},
					{
						value: 'horizontal',
						label: 'Horizontal',
					}
				],
				data: []
			}
		},

		computed: {
			...mapGetters('ERP', {
				loadingIntegrations: 'getLoading',
				availabilityEnabled: 'getAvailabilityEnabled'
			}),
			/**
			 * Computed property para verificar se existe alguma página disponível para
			 * buscar
			 */
			nextPage() {
				return this.filter.last_page && (this.filter.last_page !== this.filter.page)
			}
		},

		created() {
			if (!this.availabilityEnabled) this.$router.push('/')
		},

		mounted() {
			this.$root.$on('search-integration-availability', async (search) => {
				this.filter.last_page = 1
				this.filter.page = 1
				this.filter.total = 0
				this.filter.search = search
				this.data = []
				await this.loadData()
			})

			s3Filesystem.getIntegrationTypes().then(response => {
				this.integrationTypeOptions = Object.values(response.data.type).filter(option => option.value === 'uau')
			})
			this.loadData()
		},

		beforeDestroy() {
			this.$root.$off('search-integration-availability')
		},

		methods: {
			...mapActions('ERP', ['removeSelected']),
			/**
			 * Handler function que trata o evento de solicitação do cadastro de uma
			 * disponibilidade
			 */
			newAvailabilityHandler() {
				this.removeSelected()
				this.$router.push({ name: 'marketing.integrations.erp.availability' })
			},
			/**
			 * Busca os dados das disponibilidades das integrações de acordo com os filtros
			 * selecionados e a paginação
			 */
			loadData() {
				/**
				 * Somente seta o loading da tabela caso o loading geral das integrações esteja
				 * desabilitado
				 */
				this.loading = !this.loadingIntegrations
				/** Monta o parâmetro query whereHas */
				let whereHas = ''
				if (this.$mx_hasValue(this.filter.search)) whereHas += `product.name:${this.filter.search}`
				if (this.$mx_hasValue(this.filter.integration_type)) {
					whereHas += whereHas ? ',' : ''
					whereHas += `integrationErp.type:${this.filter.integration_type}`
				}

				/** Monta o parâmetro query where */
				let where = ''
				if (this.$mx_hasValue(this.filter.availability_type)) {
					where += `availability.type:${this.filter.availability_type}`
				}

				const params = {
					select: '',
					whereHas,
					where,
					page: this.filter.page,
					per_page: this.filter.per_page,
				}
				erp.getAllV2('products', params)
					.then(response => {
						this.data = [...this.data, ...response.data.data]
						this.filter.total = response.data.recordsFiltered || 0
						this.filter.last_page = Math.ceil(this.filter.total / this.filter.per_page)
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
					.finally(() => {
						this.loading = false
					})
			},
			/**
			 * Handler para tratar o evento de quando um select do filtro for utilizado
			 */
			selectHandler() {
				this.filter.last_page = 1
				this.filter.page = 1
				this.filter.total = 0
				this.data = []
				this.loadData()
			},
			/**
			 * Carrega a próxima página de dados disponível
			 */
			loadNextPage() {
				this.filter.page += 1
				this.loadData()
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>

